import React from "react";
import { cilCopy } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { type PositionRow, buildPositionExport, formatPositionAsJSON } from "@src/utils/formatters";
import { NO_RECORDED_MOVEMENTS } from "@src/utils/positionStatus";

interface Props {
  row: PositionRow;
}

export const PositionOnlyCell: React.FC<Props> = ({ row }) => {
  const position = row.position;
  const direction =
    position.type_name === "spot" ? "Buy" : position.direction_name === "long" ? "Long" : "Short";
  const copyPosition = () => {
    navigator.clipboard.writeText(formatPositionAsJSON(buildPositionExport(row))).catch((err) => {
      console.error("Failed to copy:", err);
    });
  };
  return (
    <div className="PositionOnlyCell">
      <div className="PositionOnlyHeader">
        <strong className="PositionOnlyIdentity">Position #{position.id}</strong>
        <span className="PositionOnlyDirection">{direction}</span>
        <button
          className="PositionOnlyCopy"
          type="button"
          onClick={copyPosition}
          aria-label="Copy position as friendly JSON"
          title="Copy position as friendly JSON"
        >
          <CIcon className="PositionOnlyCopyIcon" icon={cilCopy} size="sm" />
        </button>
      </div>
      <small className="PositionOnlyNoMovements">{NO_RECORDED_MOVEMENTS}</small>
    </div>
  );
};
